import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card";
import { Helmet } from 'react-helmet-async';

export default function Rules() {
  const navigate = useNavigate();

  // Dummy-Karten für die Anzeige
  const cardSniper = { id: "r1", type: "special", name: "Sniper", color: "black", description: "Choose a Player to deal Damage." };
  const cardHeart = { id: "r2", type: "effect", name: "Heart Container", color: "effect", description: "Increase your HP for the rest of the Game" };
  const cardStandard = { id: "r3", type: "number", color: "blue", value: 7, description: "Cards need to have the same Number or Color to be played." };

  return (
    <div style={{ 
      minHeight: "100vh", color: "white", padding: "40px 20px", fontFamily: "sans-serif", display: "flex", flexDirection: "column", alignItems: "center",
      backgroundImage: "url('/background.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" 
    }}>

        <Helmet>
        <title>How to Play & Card Rules | UN-LOCKED Card Game</title>
        <meta name="description" content="Learn how to play UN-LOCKED. Read the rules, discover all Special and Effect cards, and master the multiplayer deck building mechanics." />
      </Helmet>
      <style>{`
        button { transition: transform 0.1s ease-in-out, filter 0.1s ease-in-out, box-shadow 0.1s ease-in-out; }
        button:hover { transform: scale(1.05); filter: brightness(1.2); }
        
        /* Karten Hover Effekte nach Typ */
        .rule-card-container { transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); cursor: pointer; display: flex; flex-direction: column; align-items: center; }
        
        .rule-card-special:hover { transform: translateY(-15px) scale(1.05); }
        .rule-card-special:hover .card-glow-wrapper { box-shadow: 0 0 30px rgba(255, 0, 255, 0.8); }
        
        .rule-card-effect:hover { transform: translateY(-15px) scale(1.05); }
        .rule-card-effect:hover .card-glow-wrapper { box-shadow: 0 0 30px rgba(255, 136, 0, 0.8); }

        .rule-card-standard:hover { transform: translateY(-15px) scale(1.05); }
        .rule-card-standard:hover .card-glow-wrapper { box-shadow: 0 0 30px rgba(0, 136, 255, 0.8); }

        .card-glow-wrapper { border-radius: 12px; transition: box-shadow 0.3s ease; }
      `}</style>
      
      <div style={{ width: "100%", maxWidth: "900px", backgroundColor: "rgba(30, 30, 30, 0.8)", border: "4px solid gold", borderRadius: "20px", padding: "40px", backdropFilter: "blur(10px)", boxShadow: "0 10px 30px rgba(0,0,0,0.5)" }}>
        
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid rgba(255,215,0,0.3)", paddingBottom: "20px", marginBottom: "30px" }}>
          <h1 style={{ margin: 0, color: "white", fontSize: "2.5em", textShadow: "0 4px 10px rgba(0,0,0,0.8)" }}>Rules & Info</h1>
          <button onClick={() => navigate("/")} style={{ padding: "10px 20px", fontSize: "1.1em", backgroundColor: "#444", color: "white", border: "2px solid #777", borderRadius: "10px", cursor: "pointer", fontWeight: "bold" }}>
            Back
          </button>
        </div>

        <div style={{ marginBottom: "50px", backgroundColor: "rgba(10, 10, 10, 0.6)", padding: "30px", borderRadius: "15px", border: "1px solid #555" }}>
          <h2 style={{ color: "gold", marginTop: 0, fontSize: "1.8em" }}>Gameplay Basics</h2>
          <ul style={{ color: "#ddd", lineHeight: "1.8", fontSize: "1.2em", margin: "20px 0 0 0", paddingLeft: "20px" }}>
            <li><strong style={{ color: "white" }}>Play a Card:</strong> Play a Card of the same Color or the same Number.</li>
            <li><strong style={{ color: "white" }}>Win:</strong> The first player who achieves to have no Cards left on his Hand wins.</li>
            <li><strong style={{ color: "white" }}>HP-System:</strong> When you cant play a Card, you need to draw. Each drawn Card costs <span style={{ color: "red", fontWeight: "bold" }}>1 HP</span>. If you have no HP left, you will be eliminated.</li>
            <li><strong style={{ color: "white" }}>Shop-Phase:</strong> After every Round, you can buy new Playing, Effects and Special Cards in the Shop as well as deleting Cards from your Deck.</li>
          </ul>
        </div>

        <h2 style={{ color: "gold", fontSize: "1.8em", textAlign: "center", marginBottom: "40px" }}> Types of Cards (Example)</h2>
        
        <div style={{ display: "flex", gap: "30px", flexWrap: "wrap", justifyContent: "center" }}>
          
          {/* SPECIAL KARTE */}
          <div className="rule-card-container rule-card-special" style={{ width: "220px", textAlign: "center" }}>
            <div className="card-glow-wrapper" style={{ marginBottom: "15px", display: "inline-block" }}>
              <Card card={cardSniper} disabled={true} />
            </div>
            <h3 style={{ margin: "0 0 10px 0", color: "#ff00ff" }}>Special Cards</h3>
            <p style={{ fontSize: "0.9em", color: "#aaa", margin: 0, lineHeight: "1.4" }}>{cardSniper.description}</p>
          </div>

          {/* EFFEKT KARTE */}
          <div className="rule-card-container rule-card-effect" style={{ width: "220px", textAlign: "center" }}>
            <div className="card-glow-wrapper" style={{ marginBottom: "15px", display: "inline-block" }}>
              <Card card={cardHeart} disabled={true} />
            </div>
            <h3 style={{ margin: "0 0 10px 0", color: "#ff8800" }}>Effect Cards</h3>
            <p style={{ fontSize: "0.9em", color: "#aaa", margin: 0, lineHeight: "1.4" }}>{cardHeart.description}</p>
          </div>

          {/* STANDARD KARTE */}
          <div className="rule-card-container rule-card-standard" style={{ width: "220px", textAlign: "center" }}>
            <div className="card-glow-wrapper" style={{ marginBottom: "15px", display: "inline-block" }}>
              <Card card={cardStandard} disabled={true} />
            </div>
            <h3 style={{ margin: "0 0 10px 0", color: "#0088ff" }}>Playing Cards</h3>
            <p style={{ fontSize: "0.9em", color: "#aaa", margin: 0, lineHeight: "1.4" }}>{cardStandard.description}</p>
          </div>

        </div>
      </div>
    </div>
  );
}